import FieldDefinition from '../../../../types/common/FieldDefinition';
import IngestionConfig from '../../../../types/ingestion/IngestionConfig';
import NameAndError from '../../../../types/report/import/NameAndError';
import NumberMap from '../../../types/NumberMap';
import typeHelper from '../../common/typeHelper';

const seed = (source: IngestionConfig[], target: IngestionConfig[], fieldIds: NumberMap<number>, errors: Set<string>, mismatchedDataSources: NameAndError[]): void => {

    source.forEach(s => {

        let t = target.find(x => x.name.toLowerCase() === s.name.toLowerCase()) as IngestionConfig;

        if (!typeHelper.isObject(t)) {

            errors.add(`Data source ${s.name} was not found`);
        }

        if (t) {
            addDataSource(s, t, fieldIds, errors, mismatchedDataSources);
        }
    });
};

const addDataSource = (source: IngestionConfig, target: IngestionConfig, fieldIds: NumberMap<number>, errors: Set<string>, mismatchedDataSources: NameAndError[]): void => {

    if (source.emptyValueTokens !== target.emptyValueTokens) {

        mismatchedDataSources.push({ name: `${source.name}`, error: '' });
        return;
    }

    if (source.fieldDefinitions.length !== target.fieldDefinitions.length) {

        mismatchedDataSources.push({ name: `${source.name}`, error: '' });
        return;
    }

    for (var i = 0; i < source.fieldDefinitions.length; i++) {

        let s = source.fieldDefinitions[i];

        let t = target.fieldDefinitions.find(x => x.name === s.name) as FieldDefinition;

        if (!typeHelper.isObject(t)) {

            mismatchedDataSources.push({ name: `${source.name}`, error: '' });

            errors.add(`Field mismatch found for data source ${source.name}`);
            return;
        }

        if (s.type !== t.type) {

            errors.add(`Field ${s.name} (data source ${source.name}) has different data type in source and target environment`);
            return;
        }

        fieldIds[s.id as number] = t.id as number;
    }
};

const dataSourceFieldMapHelper = {
    seed
};

export default dataSourceFieldMapHelper;
